import { Box, TextField, MenuItem, Select, FormControl, InputLabel } from "@mui/material";

const GuestForm = ({
    handleChange,
    inputData,
    errors,
    billData,
    setBillData
}) => {
    return (
        <Box sx={{ mt: 2, mb: 2 }}>
            <TextField
                label="Full Name"
                fullWidth
                required
                name="name"
                onChange={handleChange}
                autoFocus={true}
                value={inputData?.name || ""}
                size="small"
                sx={{ mt: 2, width: "100%" }}
                {...(errors.name && {
                    error: true,
                    helperText: errors.name,
                })}
            />
            <TextField
                label="Email"
                type="email"
                fullWidth
                name="email"
                onChange={handleChange}
                value={inputData?.email || ""}
                size="small"
                sx={{ mt: 2, width: "100%" }}
                {...(errors.email && {
                    error: true,
                    helperText: errors.email,
                })}
            />
            <TextField
                label="Phone Number"
                type="number"
                fullWidth
                name="phone"
                onChange={handleChange}
                value={inputData?.phone || ""}
                size="small"
                sx={{ mt: 2, width: "100%" }}
                {...(errors.phone && {
                    error: true,
                    helperText: errors.phone,
                })}
            />
            <TextField
                label="Total Amount (Optional - Auto-calculated from room price)"
                type="number"
                fullWidth
                variant="outlined"
                size="small"
                sx={{ mt: 2, width: "100%" }}
                value={billData?.total_amount || ''}
                onChange={(e) => {
                    const value = parseFloat(e.target.value) || 0;
                    setBillData(prev => ({
                        ...prev,
                        total_amount: value
                    }));
                }}
                error={!!errors.total_amount}
                helperText={errors.total_amount || "Leave empty to auto-calculate from room price and duration"}
                InputProps={{
                    startAdornment: <span style={{ marginRight: 8 }}>₹</span>
                }}
            />
            <FormControl fullWidth size="small" sx={{ mt: 2 }}>
                <InputLabel>Payment Mode</InputLabel>
                <Select
                    name="payment_mode"
                    value={inputData?.payment_mode || "Cash"}
                    onChange={handleChange}
                    label="Payment Mode"
                >
                    <MenuItem value="Cash">Cash</MenuItem>
                    <MenuItem value="Online">Online</MenuItem>
                </Select>
            </FormControl>
        </Box>
    );
};

export default GuestForm;